module.exports = __webpack_public_path__ + "img/financialResult_3.646a3e54.png";